/*
  Variant dropdown for the "SR Product row" list layout (snippets/sr-row-card.liquid).
  Writes the chosen variant id into the hidden [name=id] input of the product form,
  and opens the list instead of submitting when nothing is chosen yet.
*/
if (!customElements.get('sr-variant-select')) {
  customElements.define(
    'sr-variant-select',
    class SrVariantSelect extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[name="id"]');
        this.details = this.querySelector('details');
        this.label = this.querySelector('[data-srvs-label]');
        this.form = this.closest('form');

        this.querySelectorAll('[data-srvs-id]').forEach((option) =>
          option.addEventListener('click', () => {
            this.input.value = option.dataset.srvsId;
            this.label.textContent = option.textContent.trim();
            this.querySelectorAll('[data-srvs-id]').forEach((el) =>
              el.setAttribute('aria-selected', el === option ? 'true' : 'false')
            );
            this.details.open = false;
          })
        );

        this.details.addEventListener('toggle', () => {
          if (!this.details.open) return;
          document.querySelectorAll('sr-variant-select details[open]').forEach((other) => {
            if (other !== this.details) other.open = false;
          });
        });

        this.onOutsideClick = (event) => {
          if (!this.contains(event.target)) this.details.open = false;
        };
        document.addEventListener('click', this.onOutsideClick);

        this.onSubmit = (event) => {
          if (this.input.value) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.details.open = true;
        };
        if (this.form) this.form.addEventListener('submit', this.onSubmit, true);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onOutsideClick);
        if (this.form) this.form.removeEventListener('submit', this.onSubmit, true);
      }
    }
  );
}
